import React, { useCallback } from "react";
import { useAppSelector } from "../../redux/configureStore";
import SessionDescription from "./SessionDescription";
import SessionVideo from "./SessionVideo";
import { getPresenters } from "./selectors";
import useSessionId from "./useSessionId";
import useVonageSession from "./useVonageSession";
import useVonageSubscribers from "./useVonageSubscribers";
import { VenueConnectionData } from "../../app/types";
import { useSession } from "../api/helpers";
import LogError from "../logging/LogError";
import Schedule from "../schedule/Schedule";

const Session = () => {
  const session = useSession();
  const sessionId = useSessionId();
  const { vonageSession } = useVonageSession();
  const publishers = useAppSelector(getPresenters(sessionId));

  const subscribers = useVonageSubscribers(vonageSession);

  const forceDisconnectSubscribers = useCallback(() => {
    if (vonageSession) {
      const pubs = publishers.map((pub) => pub.id);
      subscribers
        .filter(
          (sub) =>
            !pubs.includes((JSON.parse(sub.data) as VenueConnectionData).id),
        )
        .forEach((subscriber) =>
          vonageSession?.forceDisconnect(subscriber, (error) => {
            if (error) {
              LogError(error);
            }
          }),
        );
    }
  }, [publishers, subscribers, vonageSession]);

  if (!session) {
    return null;
  }

  return (
    <>
      <SessionVideo vonageSession={vonageSession} />
      <SessionDescription onEndSession={forceDisconnectSubscribers} />
      <Schedule />
    </>
  );
};
export default Session;
